import { ThemeEvents } from '@theme/events';

/** Replaces the badge after variant-driven section fetches (product page, quick add, swatches). */
class ProductDiscountBadge extends HTMLElement {
  #section = null;

  /** @param {Event} e */
  #onVariantUpdate = (e) => {
    if (!(e instanceof CustomEvent) || e.detail == null) return;
    if (!(e.target instanceof HTMLElement)) return;

    const { data } = e;
    if (!data?.html) return;

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (e.target instanceof HTMLElement && e.target.dataset.productId && e.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newEl = data.html.querySelector(
      `product-discount-badge[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newEl) {
      this.remove();
      return;
    }
    this.replaceWith(newEl);
  };

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#section = null;
  }
}

if (!customElements.get('product-discount-badge')) {
  customElements.define('product-discount-badge', ProductDiscountBadge);
}
